<template>
  <path
    d="M21 3.00024H3C2 3.00024 1 4.00024 1 5.00024V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22 21.0002 23 20.0002 23 19.0002V5.00024C23 4.00024 22 3.00024 21 3.00024ZM5.63 16.1902L8.12 12.9902C8.32 12.7402 8.7 12.7302 8.9 12.9802L11 15.5102L14.1 11.5202C14.3 11.2602 14.7 11.2602 14.9 11.5302L18.41 16.2102C18.66 16.5402 18.42 17.0102 18.01 17.0102H6.02C5.61 17.0002 5.37 16.5202 5.63 16.1902Z"
  />
</template>
